/** Densidade das linhas da listagem — "Tamanho da tabela" no protótipo. */
export type EmbarcacoesDensity = "confortavel" | "compacto";

/**
 * Configuração da tabela oferecida no menu ⋮ (AC4). O modal repete o de Usuários
 * e traz apenas "Tamanho da tabela": a ordenação da listagem é definida pelos
 * cabeçalhos das colunas e "Mostrar e Ocultar Colunas" está fora do escopo da
 * HU 812.
 */
export interface EmbarcacoesTableSettings {
  density: EmbarcacoesDensity;
}

export const DENSITY_OPTIONS: { value: EmbarcacoesDensity; label: string; description: string }[] =
  [
    {
      value: "confortavel",
      label: "Confortável",
      description:
        "Exibe as linhas com mais espaçamento, facilitando a leitura e diminuindo a fadiga visual.",
    },
    {
      value: "compacto",
      label: "Compacto",
      description:
        "Reduz o espaçamento entre linhas para exibir mais registros simultaneamente por tela.",
    },
  ];

export function isEmbarcacoesDensity(value: string | null): value is EmbarcacoesDensity {
  return value === "confortavel" || value === "compacto";
}
